module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.6.20.0@babel-runtime/core-js/symbol.js
 ** module id = 675
 ** module chunks = 0
 **/